<button 
    *ngIf="path == 'webpages'" mat-button class="custom-btn" (click)="openPreviewDialog()">
    <span class="material-icons custom-icon">remove_red_eye</span>
    <span class="custom-color"> Preview Website</span>
</button>